// extracted by mini-css-extract-plugin
export var container = "_ck-0";
export var infoIcon = "_ck-2";
export var titleRowCol = "_ck-1";